module.exports = __webpack_public_path__ + "assets/img/worldviewImg-ccd60b23.png";